/** MUI X pickers: 24-hour clock (no AM/PM) for all time and date-time selectors. */
export const datePickerTheme = {
  components: {
    MuiTimePicker: { defaultProps: { ampm: false } },
    MuiDateTimePicker: { defaultProps: { ampm: false } },
    MuiDesktopTimePicker: { defaultProps: { ampm: false } },
    MuiDesktopDateTimePicker: { defaultProps: { ampm: false } },
    MuiMobileTimePicker: { defaultProps: { ampm: false } },
    MuiMobileDateTimePicker: { defaultProps: { ampm: false } }
  }
}
